import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ColorVision.css";

const ColorVisionTest = () => {

  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(null);
useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  useEffect(() => {

    const email = localStorage.getItem("user_email");

    if (!email) {
      navigate("/");
      return;
    }

    axios
      .get(`/check-access?email=${email}&test=color_vision`)
      .then(res => {

        console.log("API:", res.data);

        if (res.data.allowed) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }

      })
      .catch(() => navigate("/"));

  }, []);

  if (hasAccess === null) {
    return <div>Loading...</div>;
  }

  if (hasAccess === false) {
    return (
      <div className="access-denied-container">
        <h2>🚫 Access Denied</h2>
        <p>You don’t have access to this test</p>
        <button onClick={() => navigate("/")}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="rg-login-wrapper">

      {/* ================= HEADER ================= */}

      <div className="reaction-header-card">

        <h2 className="reaction-title">Color Vision Test</h2>

        <p className="reaction-subtitle">
          Color vision is your ability to distinguish between different colors.
          This test evaluates how accurately your eyes and brain identify color patterns.
          It trains your brain to 
          <strong> “See → Differentiate → Identify.”</strong>
        </p>

        <div className="reaction-pill">
          Test type: <strong>Vision → Color Perception</strong>
        </div>

        <hr className="reaction-divider" />

        {/* ================= WHY ================= */}

        <div className="reaction-why-card">

          <h3 className="why-title">
            Why color vision matters
          </h3>

          <p className="why-description">
            Color vision is important in everyday tasks like driving, reading charts,
            identifying signals, and understanding visual data. It also helps detect
            color blindness or visual deficiencies early.
          </p>

          <div className="why-tags">
            <span>Better visual accuracy</span>
            <span>Improved observation</span>
            <span>Detect color blindness</span>
            <span>Sharper perception</span>
            <span>Faster visual processing</span>
          </div>

        </div>

      </div>

      {/* ================= HOW ================= */}

      <div className="how-card">

        <h2 className="how-title">How the test works</h2>

        <ul className="how-list">

          <li>
            You will see images made of colored dots.
          </li>

          <li>
            A number or pattern will be hidden inside the colors.
          </li>

          <li>
            Identify and select the correct number/pattern.
          </li>

          <li>
            Difficulty increases with similar color shades.
          </li>

          <li>
            The test ends when you give a wrong answer.
          </li>

        </ul>

        <p className="how-note">
          Tip: Look carefully — slight color differences matter.
        </p>

      </div>

      {/* ================= START ================= */}

      <div className="start-test-section">

        <h2>Ready to check your color vision?</h2>

        <button
          className="start-test-btn"
          onClick={() => navigate("/color-vision/play")}
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default ColorVisionTest;